import {atom} from "jotai";

export const activeYearAtom = atom<number | undefined>();
